// AdminLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import TurnstileWidget from '../components/TurnstileWidget';

function AdminLogin() {
  const [adminId, setAdminId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [turnstileToken, setTurnstileToken] = useState(null);
  const navigate = useNavigate();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!turnstileToken) {
      setError("Veuillez confirmer que vous n'êtes pas un robot.");
      return;
    }
    
    try {
      const response = await API.post('/api/admin/login', {
        admin_id: adminId,
        password: password,
      }, {
        headers: {
          'X-Turnstile-Token': turnstileToken
        }
      });
      
      localStorage.setItem('adminToken', response.data.access_token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          "Erreur lors de la connexion administrateur."
      );
    }
  };

  return (
    <div className="admin-login-container">
      <h2>Connexion Admin</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleAdminLogin}>
        <div className="form-group">
          <label>ID Admin :</label>
          <input
            type="text"
            value={adminId}
            onChange={(e) => setAdminId(e.target.value)}
            placeholder="Entrez votre ID admin"
            required
          />
        </div>
        <div className="form-group">
          <label>Mot de passe :</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Entrez votre mot de passe"
            required
          />
        </div>
        <div className="turnstile-container">
          <TurnstileWidget onVerify={setTurnstileToken} />
        </div>
        <button type="submit" className="action-button">
          Se connecter
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
